import styled from 'styled-components';

export const CheckoutContainer = styled.div`
    width: 100%;
    max-width: 1200px;
    margin: 0 auto;
    padding: 20px;
    @media screen and (max-width: 768px){
        padding: 15px;
    }
`;

export const StepIndicatorContainer = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 0;
    margin: 0 auto;
    max-width: 600px;
`;

export const StepIndicator = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 8px;
    cursor: ${props => props.active ? 'pointer' : 'default'};
    opacity: ${props => props.active ? 1 : 0.5};
`;

export const StepIcon = styled.div`
    width: 40px;
    height: 40px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: ${props => props.completed ? '#028322' : '#fff'};
    border: 2px solid ${props => props.completed ? '#028322' : '#d1d5db'};
    color: ${props => props.completed ? '#fff' : '#9ca3af'};
    font-weight: 600;
    transition: all 0.2s;
`;

export const StepLabel = styled.span`
    font-size: 14px;
    font-weight: 500;
    color: #6b7280;
`;

export const StepLine = styled.div`
    width: 80px;
    height: 2px;
    background-color: ${props => props.active ? '#028322' : '#d1d5db'};
    margin: 0 -10px;
    margin-bottom: 20px;
    transition: all 0.2s;
    @media screen and (max-width: 600px){
        width: 40px;
    }
`;

export const CheckoutMainContent = styled.div`
    flex: 1;
    display: flex;
    flex-direction: column;
    gap: 20px;
`;

export const CheckoutSummaryPanel = styled.div`
    width: 380px;
    height: fit-content;
    position: sticky;
    top: 80px;
    background-color: #fff;
    border: 1px solid #e5e7eb;
    border-radius: 12px;
    padding: 24px;
    @media screen and (max-width: 1024px){
        width: 100%;
        position: relative;
        top: 0;
        order: -1;
        margin-bottom: 30px;
    }
`;

export const SectionTitle = styled.h2`
    font-size: 1.5rem;
    fontWeight: 600;
    color: #1f2937;
    margin: 0 0 20px 0;
`;

export const ProductCard = styled.div`
    display: flex;
    gap: 16px;
    background-color: #fff;
    border: 1px solid #e5e7eb;
    border-radius: 12px;
    padding: 16px;
    transition: all 0.2s;
    &:hover {
        box-shadow: 0 4px 12px rgba(0,0,0,0.08);
    }
    @media screen and (max-width: 600px){
        flex-direction: column;
    }
`;

export const ProductImage = styled.img`
    width: 80px;
    height: 80px;
    min-width: 80px;
    min-height: 80px;
    object-fit: cover;
    border-radius: 8px;
    cursor: pointer;
    @media screen and (max-width: 600px){
        width: 100%;
        height: 150px;
        min-width: unset;
    }
`;

export const ProductInfo = styled.div`
    flex: 1;
    display: flex;
    flex-direction: column;
    gap: 8px;
`;

export const ProductName = styled.div`
    font-size: 16px;
    font-weight: 500;
    color: #1f2937;
    cursor: pointer;
    &:hover {
        text-decoration: underline;
    }
`;

export const ProductPrice = styled.div`
    font-size: 18px;
    font-weight: 600;
    color: #028322;
`;

export const QuantityControls = styled.div`
    display: flex;
    align-items: center;
    gap: 0;
    margin-left: auto;
    @media screen and (max-width: 600px){
        margin-left: 0;
        justify-content: flex-end;
    }
`;

export const QuantityButton = styled.button`
    width: 32px;
    height: 32px;
    border: 1px solid #d1d5db;
    background-color: #fff;
    color: #028322;
    font-size: 18px;
    font-weight: 600;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.2s;
    &:hover {
        background-color: #f9fafb;
        border-color: #028322;
    }
    &:first-child {
        border-radius: 6px 0 0 6px;
    }
`;

export const QuantityInput = styled.input`
    width: 50px;
    height: 32px;
    border: 1px solid #d1d5db;
    border-left: none;
    border-right: none;
    text-align: center;
    font-size: 14px;
    font-weight: 500;
    outline: none;
`;

export const DeleteButton = styled.button`
    width: 36px;
    height: 32px;
    border: 1px solid #d1d5db;
    border-radius: 0 6px 6px 0;
    background-color: #fff;
    color: #ef4444;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-left: 8px;
    transition: all 0.2s;
    &:hover {
        background-color: #fef2f2;
        border-color: #ef4444;
    }
`;

export const AddressOption = styled.div`
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 16px;
    border: 2px solid ${props => props.selected ? '#028322' : '#e5e7eb'};
    background-color: ${props => props.selected ? '#f0fdf4' : '#fff'};
    border-radius: 12px;
    cursor: pointer;
    transition: all 0.2s;
    &:hover {
        border-color: #028322;
        background-color: #f0fdf4;
    }
`;

export const RadioButton = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
`;

export const AddressOptionContent = styled.div`
    flex: 1;
    display: flex;
    flex-direction: column;
    gap: 4px;
`;

export const AddressText = styled.div`
    font-size: 14px;
    color: #6b7280;
`;

export const PaymentOption = styled.div`
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 16px;
    border: 2px solid ${props => props.selected ? '#028322' : '#e5e7eb'};
    background-color: ${props => props.selected ? '#f0fdf4' : '#fff'};
    border-radius: 12px;
    cursor: pointer;
    transition: all 0.2s;
    &:hover {
        border-color: #028322;
        background-color: #f0fdf4;
    }
`;

export const ShippingInfo = styled.div`
    display: flex;
    align-items: center;
    gap: 16px;
    padding: 20px;
    background-color: #ecfdf5;
    border: 1px solid #10b981;
    border-radius: 12px;
`;

export const SummaryItem = styled.div`
    display: flex;
    justify-content: space-between;
    padding: 12px 0;
    border-bottom: 1px solid #f3f4f6;
    font-size: 14px;
    color: #6b7280;
`;

export const SummaryTotal = styled.div`
    display: flex;
    justify-content: space-between;
    padding: 16px 0;
    font-size: 18px;
    font-weight: 700;
    color: #1f2937;
    border-top: 2px solid #e5e7eb;
    margin-top: 8px;
`;

export const ContinueButton = styled.button`
    width: 100%;
    padding: 14px;
    background-color: #028322;
    color: #fff;
    font-size: 16px;
    font-weight: 600;
    border: none;
    border-radius: 8px;
    cursor: pointer;
    margin-top: 16px;
    transition: all 0.2s;
    &:hover {
        background-color: #026a1b;
    }
    &:disabled {
        background-color: #9ca3af;
        cursor: not-allowed;
    }
`;

export const BackButton = styled.button`
    width: 100%;
    padding: 12px;
    background-color: transparent;
    color: #6b7280;
    font-size: 14px;
    font-weight: 500;
    border: none;
    cursor: pointer;
    margin-top: 8px;
    transition: all 0.2s;
    &:hover {
        color: #028322;
    }
`;
